import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Procedure.css';

function Procedure() {
  const [selectedBubble, setSelectedBubble] = useState(null);

  const procedureDetails = {
    purchase: {
      title: 'Purchase Order Procedures',
      content: [
        'Request proforma invoice from supplier',
        'Upload to SharePoint',
        'Wait for admin to share the PO'
      ]
    },
    delivery: {
      title: 'Delivery Note Procedures',
      content: [
        'Once you receive the material verify the quantity',
        'Verify the quality',
        'Sign the DN',
        'Scan and upload to SharePoint'
      ]
    },
    invoice: {
      title: 'Invoice Procedures',
      content: [
        'Once you receive the Invoice from Suppliers',
        'Inspect the TIN and VRN number',
        'Then compare it with the DELIVERY NOTE',
        'Check if the invoice amount is okay',
        'Combine the Invoice document with the EFD, DN and PO',
        'Then send it to Admin for payment'
      ]
    }
  };

  return (
    <div className="procedure-page">
      <div className="page-header">
        <div className="breadcrumb">
          <Link to="/" className="breadcrumb-item clickable">Dashboard</Link>
          <span className="breadcrumb-separator">›</span>
          <span className="breadcrumb-item active">Procedure</span>
        </div>
        <h1>Procedure</h1>
        <p>Standard operating procedures and guidelines</p>
      </div>

      <div className="procedure-content">
        <div className="bubbles-container">
          {/* First Bubble - Purchase order procedures (Blue) */}
          <div 
            className={`bubble-wrapper ${selectedBubble && selectedBubble !== 'purchase' ? 'faded' : ''}`}
            onClick={() => setSelectedBubble(selectedBubble === 'purchase' ? null : 'purchase')}
            style={{ cursor: 'pointer' }}
          >
            <div className={`bubble-main bubble-blue ${selectedBubble === 'purchase' ? 'selected' : ''}`}>
              <div className="bubble-text">Purchase order<br />procedures</div>
              {selectedBubble === 'purchase' && (
                <div className="bubble-mirror"></div>
              )}
            </div>
            <div className="bubble-small bubble-blue-small bubble-top-left"></div>
            <div className="bubble-decorative bubble-blue-light bubble-1"></div>
            <div className="bubble-decorative bubble-blue-light bubble-2"></div>
            <div className="bubble-decorative bubble-blue-light bubble-3"></div>
            <div className="bubble-decorative bubble-blue-light bubble-4"></div>
            <div className="bubble-decorative bubble-blue-light bubble-5"></div>
          </div>

          {/* Second Bubble - Delivery procedures (Teal) */}
          <div 
            className={`bubble-wrapper ${selectedBubble && selectedBubble !== 'delivery' ? 'faded' : ''}`}
            onClick={() => setSelectedBubble(selectedBubble === 'delivery' ? null : 'delivery')}
            style={{ cursor: 'pointer' }}
          >
            <div className={`bubble-main bubble-teal ${selectedBubble === 'delivery' ? 'selected' : ''}`}>
              <div className="bubble-text">Delivery<br />procedures</div>
              {selectedBubble === 'delivery' && (
                <div className="bubble-mirror"></div>
              )}
            </div>
            <div className="bubble-small bubble-teal-small bubble-top-right"></div>
            <div className="bubble-decorative bubble-teal-light bubble-6"></div>
            <div className="bubble-decorative bubble-teal-light bubble-7"></div>
            <div className="bubble-decorative bubble-teal-light bubble-8"></div>
            <div className="bubble-decorative bubble-teal-light bubble-9"></div>
            <div className="bubble-decorative bubble-teal-light bubble-10"></div>
          </div>

          {/* Third Bubble - Invoice procedures (Dark Blue) */}
          <div 
            className={`bubble-wrapper ${selectedBubble && selectedBubble !== 'invoice' ? 'faded' : ''}`}
            onClick={() => setSelectedBubble(selectedBubble === 'invoice' ? null : 'invoice')}
            style={{ cursor: 'pointer' }}
          >
            <div className={`bubble-main bubble-indigo ${selectedBubble === 'invoice' ? 'selected' : ''}`}>
              <div className="bubble-text">Invoice<br />procedures</div>
              {selectedBubble === 'invoice' && (
                <div className="bubble-mirror"></div>
              )}
            </div>
            <div className="bubble-small bubble-indigo-small bubble-bottom-left"></div>
            <div className="bubble-small bubble-indigo-small bubble-top-right-2"></div>
            <div className="bubble-decorative bubble-indigo-light bubble-11"></div>
            <div className="bubble-decorative bubble-indigo-light bubble-12"></div>
            <div className="bubble-decorative bubble-indigo-light bubble-13"></div>
            <div className="bubble-decorative bubble-indigo-light bubble-14"></div>
            <div className="bubble-decorative bubble-indigo-light bubble-15"></div>
          </div>
        </div>

        {/* Procedure Details Block - Horizontal Display */}
        {selectedBubble && (
          <div className={`procedure-details-block procedure-details-${selectedBubble}`}>
            <h2>{procedureDetails[selectedBubble].title}</h2>
            <div className="procedure-steps-horizontal">
              {procedureDetails[selectedBubble].content.map((item, index) => (
                <div key={index} className="procedure-step-block">
                  <div className="step-number">{index + 1}</div>
                  <div className="step-text">{item}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Procedure;

